<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section class="mt-3 mb-2 text-center" v-if="person">
    <div v-if="!person.created_by_prison && person.verification_status !== 'Unverified'" class="row">
      <div class="col-12">
        <h5>Identity Type: <b>{{getIdentityType()}}</b></h5>
        <h5>
          Purple Visits Confidence Rating
          <span
            class="fas fa-info-circle hover"
            data-toggle="tooltip"
            data-placement="top"
            title="We have used our facial verification algorithm and the rating provided is out of 100%. Anything above 75% is considered a match. Please note anyone with the ID type of Child will have a score of zero as we have no reference image to compare it to."
          ></span>
        </h5>
      </div>
      <div class="col-12">
        <h4 cy="confidence"><b>{{person.identity.confidence}}</b></h4>
      </div>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';

  export default {
    components: {},
    props: {
      person: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        test: '',
      };
    },
    computed: {
      ...mapState({}),
    },
    mounted() {

    },
    methods: {
      getIdentityType() {
        if (this.person && this.person.assets) {
          if (this.person.assets.id_type === 'DrivingLicence') {
            return 'Driving Licence';
          }  else if(this.person.assets.id_type === 'GovernmentIssuedId') {
            return 'Government Issued Id';
          }
          return this.person.assets.id_type;
        }
        return '-';
      },
    },
  };
</script>
